import wizard_nav_footerHtml from './wizard-nav-footer.html?raw';

export const template = wizard_nav_footerHtml;

export interface IWizardNavFooterParams {
    showPrevious: KnockoutObservable<boolean>;
    showNext: KnockoutObservable<boolean>;
    showCancel: KnockoutObservable<boolean>;
    canGoPrevious: KnockoutObservable<boolean>;
    canGoNext: KnockoutObservable<boolean>;
    onPrevious: () => void;
    onNext: () => void;
    onCancel: () => void;
    nextLabelKey: KnockoutObservable<string>;
    nextButtonClassMap: KnockoutObservable<Record<string, boolean>>;
    cancelLabelKey: KnockoutObservable<string>;
    cancelIcon: KnockoutObservable<string>;
}

export class viewModel {
    constructor(public params: IWizardNavFooterParams) {}
}
